import React, { useRef } from 'react'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Stack,
} from '@chakra-ui/react'
import { Button } from 'components/common'
import colors from 'style/color'

export type DialogOptions = {
  catchOnCancel?: boolean
  variant: 'alert' | 'confirm'
  title?: string
  description?: string | JSX.Element
  cancelText?: string
  submitText?: string
  submitColor?: keyof typeof colors
}

type ConfirmationModalProps = DialogOptions & {
  isOpen: boolean
  onSubmit: () => void
  onClose: () => void
}

const Component: React.FC<ConfirmationModalProps> = ({
  isOpen,
  title,
  variant,
  description,
  onSubmit,
  onClose,
  cancelText = 'キャンセル',
  submitText = variant === 'alert' ? '閉じる' : 'OK',
  submitColor = 'primary',
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null)
  const color = submitColor === 'primary' ? 'primary.500' : 'danger.500'

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      closeOnOverlayClick={false}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent size="xs" width="80vw" height="auto" rounded="sm" p={0}>
        {title != null && (
          <AlertDialogHeader fontSize="lg" fontWeight="bold" textAlign="center">
            {title}
          </AlertDialogHeader>
        )}

        {description != null && (
          <AlertDialogBody pt={title != null ? 2 : 4}>{description}</AlertDialogBody>
        )}

        <AlertDialogFooter display="block">
          {variant === 'confirm' && (
            <Stack spacing={2}>
              <Button color={color} shape="rounded" onClick={onSubmit} h="40px">
                {submitText}
              </Button>
              <Button
                color="neutralgray"
                shape="rounded"
                ref={cancelRef}
                onClick={onClose}
                h="40px"
              >
                {cancelText}
              </Button>
            </Stack>
          )}
          {variant === 'alert' && (
            <Stack>
              <Button ref={cancelRef} onClick={onSubmit} color={color} shape="rounded" h="40px">
                {submitText}
              </Button>
            </Stack>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default Component
